import { gql } from '@apollo/client'

import { TaskLibraryFragment } from '../fragments'

export const TASK_LIBRARIES = gql`
  query taskLibraries {
    taskLibraries {
      ...TaskLibraryFragment
    }
  }
  ${TaskLibraryFragment}
`

export const TASK_LIBRARY = gql`
  query taskLibrary($id: ID!) {
    taskLibrary(id: $id) {
      ...TaskLibraryFragment
    }
  }
  ${TaskLibraryFragment}
`
